// AllTermsAndConditions.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const BASE_URL = 'https://api.sofiasurgicals.com/api';

const AllTermsAndConditions = () => {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkExisting = async () => {
      try {
        // ✅ FIX: correct T&C endpoint
        const res = await axios.get(`${BASE_URL}/get-TermsAndCondition`);
        navigate(`/edit-TermsAndCondition/${res.data._id}`, { replace: true });
      } catch (err) {
        if (err.response?.status === 404) {
          navigate('/add-TermsAndCondition', { replace: true });
        } else {
          console.error(err);
          setChecking(false);
        }
      }
    };
    checkExisting();
  }, [navigate]);

  if (checking) {
    return (
      <div className="d-flex justify-content-center align-items-center mt-5">
        <div className="spinner-border text-primary me-2" role="status" />
        <span>Loading Terms & Conditions...</span>
      </div>
    );
  }

  return (
    <p className="text-center mt-4 text-danger">
      Failed to load Terms & Conditions. Please try again.
    </p>
  );
};

export default AllTermsAndConditions;